import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers   } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable }     from 'rxjs/Observable';


import { Categoria } from '../model/Categoria';
import { Subcategoria } from '../model/Subcategoria';


import { UtilitiesService } from '../services/utilities.service'

@Injectable()
export class SubcategoriaService {

    constructor(
    private _http: Http,
    private _utilities:UtilitiesService
  ) { }


  getSubcategorias(query: any) : Observable<Subcategoria[]> {
    
    let json = { "Metodo": "findSubCategoria", "Datos": query};

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));

		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
		return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());
   }

   public insert(subcategoria: Subcategoria){
   
    let json = {   "Metodo": "postSubCategoria",   "Datos": subcategoria };
    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());
  }


public delete(subCategoria: Subcategoria){
  
    let json = {   "Metodo": "deleteSubCategoria",   "Datos": subCategoria  };
    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/subcategoria.service.ts